"use client";

import { useEffect } from "react";
import { setupGlobalErrorHandler } from "@/services/errorLog";
import { addStartupMark } from "@/lib/runtimeDiagnostics";

/**
 * Component to setup global error handlers
 * Should be included once in the root layout
 */
export function ErrorLoggerSetup() {
  useEffect(() => {
    addStartupMark("error_logger_setup_mount");
    const cleanup = setupGlobalErrorHandler();
    addStartupMark("error_logger_setup_ready");
    return cleanup;
  }, []);

  return null;
}
